import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/vercel/path1/apps/app/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PropertyChatProvider"] */ "/vercel/path1/apps/app/src/contexts/property-chat-context.tsx");
